window.GAS || ( GAS = {} );

GAS.init = function() {
  var _this = GAS;

  _this.vars = {
    $body: $( 'body' ),
    $window: $( window )
  };

  _this.features.nav.init();
  _this.features.onePageNavigation.init();
  _this.features.quickTips.init();

  if ( !window.RailsEnv || window.RailsEnv !== "test" ) _this.features.stickyHeader.init();
};

(function( window, document ) {
  var _self = GAS.features = {
    nav: {
      init: function() {
        $allItems = $('#primary-navigation > ul > li')
        $currentPrimaryNavItem = $allItems.filter('.active')

        $('#primary-navigation > ul').menuAim({
          activate: function(entry) {
            $allItems.removeClass('active');
            $(entry).addClass('active');
          },
          rowSelector: '> li',
          submenuDirection: 'below',
          tolerance: 100
        }).on('mouseleave', function() {
          $('#primary-navigation > ul > li.active').removeClass('active')
          $currentPrimaryNavItem.addClass('active')
        })
      }
    },

    onePageNavigation: {
      init: function() {
        $( '#onepage-navigation' ).onePageNav({
          currentClass: 'active',
          scrollOffset: 0,
          scrollSpeed: 500,
          scrollThreshold: 0.25
        });
      }
    },

    quickTips: {
      init: function() {
        var activeClass = 'active', inactiveClass = 'inactive';

        if ( $('.quick-tips-button').length > 0 && !$('.quick-tips-button').hasClass(activeClass) ) {
          $('.quick-tip').addClass(inactiveClass);
        }

        GAS.vars.$body.find( '.quick-tips-button' ).on( 'click.gas', function( event ) {
          var $this = $( this ),
            $quickTips = $(".quick-tip"),
            $quickTipButtons = $(".quick-tips-button");

          if ( $this.hasClass( activeClass ) ) {
            $quickTipButtons.removeClass( activeClass );
            $quickTipButtons.text(t("phrases.quick_tips_off"));
            $quickTips.addClass( inactiveClass );
          } else {
            $quickTipButtons.addClass( activeClass );
            $quickTipButtons.text(t("phrases.quick_tips_on"));
            $quickTips.removeClass( inactiveClass );
          }

          jQuery.get(Routes.toggle_quick_tips_tools_path());
        });
      }
    },

    stickyHeader: {
      init: function() {
        GAS.vars.$body.stickem({
          container: '.global-content',
          item: '.sticky-header',
          start: 37,
          stickClass: 'stuck'
        });
      }
    }
  };
})( window, document );

$( document ).ready( GAS.init );
